const LivingBelowChallenge2HintsText =
    ["There are a total of 4 items that should be moved to the 'Advantages' column.",
     "Unfortunately, you probably can't spend money whenever you want and still live below your means.",
     "If you live below your means, you will have money after all of your bills have been paid. " +
     "This will make it easier to get a loan if you need one.",
     "If you are careful with your money, you can save up and do many things that are fun." ,
    ]
   

export default LivingBelowChallenge2HintsText;